import React, { useEffect, useState } from 'react';

function Acrostic() {
  
  const [acrosticInput, setAcrosticInput] = useState('');
  const [matchingAcrosticWords, setMatchingAcrosticWords] = useState([]);

  useEffect(() => {
    // Fetch the contents of gematria_output.txt with UTF-8 encoding
    fetch('/hebrew_words2.txt', {
      headers: {
        'Content-Type': 'text/plain; charset=utf-8',
        'X-Content-Type-Options': 'nosniff',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      
  
      })

  const handleAcrosticSubmit = () => {
    const acrosticLetters = acrosticInput.split('');
    const convertedAcrosticLetters = acrosticLetters.map((letter) => {
      if (letter === 'ך') return 'כ';
      if (letter === 'ץ') return 'צ';
      if (letter === 'ף') return 'פ';
      if (letter === 'ן') return 'נ';
      if (letter === 'ם') return 'מ';
      return letter;
    });

    const acrosticWords = [];
    const unmatchedLetters = [];

    fetch('/hebrew_words2.txt', {
      headers: {
        'Content-Type': 'text/plain; charset=utf-8',
        'X-Content-Type-Options': 'nosniff',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((data) => {
        const lines = data.split('\n');
        const letterToWordMap = {};

        // Build a map of letters to words that start with that letter
        for (const line of lines) {
          const [word, value] = line.split(':');
          const firstLetter = word.charAt(0);
          if (!(firstLetter in letterToWordMap)) {
            letterToWordMap[firstLetter] = [];
          }
          letterToWordMap[firstLetter].push(word);
        }

        // Generate the acrostic by finding words for each letter
        convertedAcrosticLetters.forEach((letter) => {
          if (letter in letterToWordMap) {
            const matchingWords = letterToWordMap[letter];
            if (matchingWords.length > 0) {
              const word = matchingWords.shift(); // Get the first word
              acrosticWords.push(word);
            } else {
              // Handle unmatched letters
              unmatchedLetters.push(letter);
            }
          } else {
            // Handle unmatched letters
            unmatchedLetters.push(letter);
          }
        });

        setMatchingAcrosticWords(acrosticWords);

        // Display a message for unmatched letters
        if (unmatchedLetters.length > 0) {
          console.warn(`No matching words found for letters: ${unmatchedLetters.join(', ')}`);
        }
      })
      .catch((error) => {
        console.error('Error fetching or parsing file:', error);
      });
  };

  const handleAcrosticInputChange = (event) => {
    setAcrosticInput(event.target.value);
  };

  return (
    <div className="App">
    
      <p>Enter a Hebrew word below and to generate an acrostic using Torah words:</p>
      <input
        type="text"
        value={acrosticInput}
        onChange={handleAcrosticInputChange}
        placeholder="Type here..."
      />
      <button onClick={handleAcrosticSubmit}>Generate Acrostic</button>
      
      {matchingAcrosticWords.length > 0 && (
        <div>
          <p>Generated Acrostic Words:</p>
          <ul>
            {matchingAcrosticWords.map((word, index) => (
              <li key={index}>{word}</li>
            ))}
          </ul>
        </div>
      )}
      <p></p>
    </div>
  );
}

export default Acrostic;
